import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import { Modal, Loader, Dimmer } from "semantic-ui-react";
const SMART_WIDGET_CSS = "https://static.smartrecruiters.com/job-widget/1.7.2/css/smart_widget.css";
const SmartRecruitersWidget = ({ isOpen, toggleOpen, isStatic }) => {
    if (isStatic)
        return null;
    const iframeRef = useRef(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        var _a;
        if (isOpen && iframeRef.current) {
            setLoading(true);
            const iframe = iframeRef.current;
            const doc = iframe.contentDocument || ((_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document);
            if (doc) {
                doc.open();
                doc.write(`
                    <!DOCTYPE html>
                    <html lang="en">
                    <head>
                        <meta charset="UTF-8" />
                        <link rel="stylesheet" href="${SMART_WIDGET_CSS}" />
                        <style>
                            body { margin: 0; background: #fff; }
                        </style>
                    </head>
                    <body>
                        <div id="smart-recruiters-widget"></div>
                        <script type="text/javascript" src="https://static.smartrecruiters.com/job-widget/1.7.2/script/smart_widget.js"></script>
                        <script type="text/javascript" class="job_widget">
                            widget({
                                "company_code": "InstantScripts",
                                "departments_field_id": null,
                                "jobAdType": "PUBLIC",
                                "api_url": "https://www.smartrecruiters.com",
                                "custom_css_url": "https://static.smartrecruiters.com/job-widget/1.7.2/css/smart_widget.css",
                                "job_ad_url": "https://jobs.smartrecruiters.com",
                                "bg_color_even_row": "#FAFAFA",
                                "bg_color_headers": "#0065F2",
                                "bg_color_links": "#3C96FB",
                                "bg_color_odd_row": "#C5E5FF",
                                "bg_color_widget": "#FFFFFF",
                                "txt_color_headers": "#FFFFFF",
                                "txt_color_job": "#515151",
                                "auto_height": "auto",
                                "auto_width": "auto",
                                "job_title": "true",
                                "location": "true",
                                "type_of_employment": "true",
                                "department": "false",
                                "published_since": "true",
                                "dateFormat": "eu",
                                "remove_headers": "false",
                                "add_search": "false",
                                "trid": "998bc6c9-cfbe-4db9-af4b-d7bb8407f264"
                            });
                        </script>
                    </body>
                    </html>
                `);
                doc.close();
                // Wait for iframe to load content
                const handleLoad = () => setLoading(false);
                iframe.addEventListener("load", handleLoad);
                // Clean up event listener
                return () => {
                    iframe.removeEventListener("load", handleLoad);
                };
            }
        }
        if (!isOpen && iframeRef.current) {
            const doc = iframeRef.current.contentDocument;
            if (doc)
                (doc.open(), doc.write(""), doc.close());
            setLoading(false);
        }
    }, [isOpen]);
    return (_jsxs(Modal, { open: isOpen, onClose: toggleOpen, closeIcon: true, size: "large", "aria-modal": "true", "aria-label": "Careers", children: [_jsx(Modal.Header, { children: "Careers at InstantScripts" }), _jsx(Modal.Content, { scrolling: true, children: _jsxs("div", { style: { position: "relative", minHeight: 600 }, children: [loading && (_jsx(Dimmer, { active: true, inverted: true, children: _jsx(Loader, { children: "Loading jobs..." }) })), _jsx("iframe", { ref: iframeRef, title: "SmartRecruiters Widget", width: "100%", height: "600", style: { border: "none", display: loading ? "none" : "block" }, sandbox: "allow-scripts allow-same-origin allow-popups" })] }) })] }));
};
export default SmartRecruitersWidget;
